import { BMP_AutomaticAlert } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPAutomaticAlerts = (): Promise<BMP_AutomaticAlert[]> => {
    return new Promise<BMP_AutomaticAlert[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/automaticalerts`).then((response) => {
            resolve(response.data as BMP_AutomaticAlert[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};